import { Component, OnInit } from '@angular/core';
import {
    Router,
    ActivatedRoute,
    NavigationEnd,
    Params,
    PRIMARY_OUTLET } from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
    selector: 'itpx-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styles: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {

    public breadcrumbs: any[];
    private startRoute: string = 'dashboard';

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.breadcrumbs = [];
    }

    ngOnInit() {

        const ROUTE_DATA_BREADCRUMB: string = 'breadcrumb';

        // subscribe to the NavigationEnd event
        this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
            // set breadcrumbs
            let root: ActivatedRoute = this.activatedRoute.root;
            this.breadcrumbs = this.getBreadcrumbs(root);
        });
    }

    private getBreadcrumbs(route: ActivatedRoute, url: string='', breadcrumbs: any[]=[]): any[] {
        const ROUTE_DATA_BREADCRUMB: string = 'breadcrumb';
        const ROUTE_DATA_FORCEURL: string = 'forceUrl';

        // get the child routes
        let children: ActivatedRoute[] = route.children;

        // return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }

        // iterate over each children
        for (let child of children) {
            // verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            if (!child.snapshot.data[ROUTE_DATA_BREADCRUMB]) {
                continue;
            }

            // get the route's URL segment
            let label = child.snapshot.data[ROUTE_DATA_BREADCRUMB];
            let forceUrl = child.snapshot.data[ROUTE_DATA_FORCEURL];
            let routeURL = child.snapshot.url.map(segment => segment.path).join('/');

            let lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];

            if(!breadcrumbs.length || (lastBreadcrumb.label !== label)) {
                if(routeURL !== this.startRoute) {
                    // append route URL to URL
                    url += `/${routeURL}`;

                    // add restore=true; to the url only if it is specified in the route
                    let params = child.snapshot.data['restore'] ? Object.assign({restore: true}, child.snapshot.params) :
                    child.snapshot.params;

                    // add breadcrumb
                    let breadcrumb: any = {
                        label: label,
                        params: params,
                        url: url
                    };

                    if (child.snapshot.data.overridePrevious && breadcrumbs.length > 0) {
                        breadcrumbs.pop();
                    }

                    breadcrumbs.push(breadcrumb);
                }
            }

            if (forceUrl && breadcrumbs.length ) {
                breadcrumbs[0].url = forceUrl;
            }

            // recursive
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/breadcrumbs/breadcrumbs.component.ts